import {css} from 'lit';

export default css`

.quick-links {
  position: relative;
}
.quick-links__menu {
  background-color: #fff;
}
@media (max-width: 991px) {
  .quick-links__menu a {
    display: flex;
    align-items: center;
    min-height: 3rem;
    padding-left: 1em;
    border-bottom: 1px solid #4c4c4c;
    background: #fff;
    font-weight: 400;
    line-height: 1.25;
    text-decoration: none;
  }
  .quick-links__menu a:hover {
    background: #ffbf00;
  }
  .quick-links__menu a .active {
    background: #ffbf00;
  }
}
@media (min-width: 992px) {
  .quick-links__menu {
    position: absolute;
    top: 3.25rem;
    right: 0;
    width: 22rem;
    border-top: 1px solid #13639e;
    box-shadow: 0 1px 2px rgba(2, 40, 81, 0.7);
  }
  .quick-links__menu .menu {
    position: relative;
    z-index: 840;
    padding: 1rem 0;
  }
  .quick-links__menu a {
    display: block;
    padding: 0.5rem 1.5rem;
    font-weight: 400;
    line-height: 1.35;
    text-decoration: none;
  }
  .quick-links__menu a:hover {
    text-decoration: underline;
  }
}
.quick-links__menu a {
  color: #000;
}
.quick-links__menu a:focus {
  background: #ffbf00;
}
@media (min-width: 992px) {
  .quick-links--home-site {
    border-top: 0;
  }
  .quick-links--home-site .menu {
    padding-top: 9.75rem;
  }
  .quick-links--home-site li:first-child,
  .quick-links--home-site li:nth-child(2),
  .quick-links--home-site li:nth-child(3) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #fff;
    background-color: #ffecb2;
  }
  .quick-links--home-site li:first-child a,
  .quick-links--home-site li:nth-child(2) a,
  .quick-links--home-site li:nth-child(3) a {
    display: flex;
    align-items: center;
    padding: 1rem 1rem 1rem 0.75rem;
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
  }
  .quick-links--home-site li:first-child a:before,
  .quick-links--home-site li:nth-child(2) a:before,
  .quick-links--home-site li:nth-child(3) a:before {
    margin-right: 0.5rem;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
  }
  .quick-links--home-site li:first-child a:hover,
  .quick-links--home-site li:nth-child(2) a:hover,
  .quick-links--home-site li:nth-child(3) a:hover {
    background-color: #ffbf00;
  }
  .quick-links--home-site li:first-child a:before,
  .quick-links--home-site li:nth-child(2) a:before,
  .quick-links--home-site li:nth-child(3) a:before {
    min-width: 1rem;
    margin-right: 0.75rem;
    color: #13639e;
    font-size: 0.875em;
  }
  .quick-links--home-site li:nth-child(2) {
    top: 3.2175rem;
    border-top: 2px solid #fff;
  }
  .quick-links--home-site li:nth-child(3) {
    top: 6.435rem;
    border-top: 2px solid #fff;
  }
  .quick-links--home-site li:first-child a:before {
    content: '\\f406';
  }
  .quick-links--home-site li:nth-child(2) a:before {
    content: '\\f058';
  }
  .quick-links--home-site li:nth-child(3) a:before {
    content: '\\f06b';
  }
}
@media (min-width: 992px) {
  .quick-links--highlight {
    border-top: 0;
  }
  .quick-links--highlight .menu {
    padding-top: 9.75rem;
  }
  .quick-links--highlight li:first-child,
  .quick-links--highlight li:nth-child(2),
  .quick-links--highlight li:nth-child(3) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #fff;
    background-color: #ffecb2;
  }
  .quick-links--highlight li:first-child a,
  .quick-links--highlight li:nth-child(2) a,
  .quick-links--highlight li:nth-child(3) a {
    display: flex;
    align-items: center;
    padding: 1rem 1rem 1rem 0.75rem;
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
  }
  .quick-links--highlight li:first-child a:before,
  .quick-links--highlight li:nth-child(2) a:before,
  .quick-links--highlight li:nth-child(3) a:before {
    margin-right: 0.5rem;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
  }
  .quick-links--highlight li:first-child a:hover,
  .quick-links--highlight li:nth-child(2) a:hover,
  .quick-links--highlight li:nth-child(3) a:hover {
    background-color: #ffbf00;
  }
  .quick-links--highlight li:first-child a:before,
  .quick-links--highlight li:nth-child(2) a:before,
  .quick-links--highlight li:nth-child(3) a:before {
    min-width: 1rem;
    margin-right: 0.75rem;
    color: #13639e;
    font-size: 0.875em;
  }
  .quick-links--highlight li:nth-child(2) {
    top: 3.2175rem;
    border-top: 2px solid #fff;
  }
  .quick-links--highlight li:nth-child(3) {
    top: 6.435rem;
    border-top: 2px solid #fff;
  }
}
@media (min-width: 992px) {
  .quick-links--two-columns .menu {
    column-count: 2;
    column-gap: 0;
  }
  .quick-links--two-columns a {
    break-inside: avoid;
  }
}
.quick-links__title {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
  justify-content: space-between;
  margin: 0;
  padding-right: 0;
  padding-left: 1rem;
  border: 0;
  appearance: none;
  color: #fff;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 400;
  text-decoration: none;
}
.quick-links__title:after {
  margin-left: 0.5rem;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
@media (max-width: 991px) {
  .quick-links__title {
    overflow: hidden;
    width: 100%;
    border-bottom: 0.15rem solid #fff;
    background-color: #13639e;
  }
  .quick-links__title .submenu-toggle {
    height: 3rem;
    border: 0;
  }
}
@media (min-width: 992px) {
  .quick-links__title {
    margin-left: 1rem;
    padding: 0 1rem 0 0;
    background-color: #13639e;
    font-size: 0.85rem;
  }
  .quick-links__title:before {
    width: 1rem;
    height: 3.25rem;
    margin-right: 0.5rem;
    margin-left: -1rem;
    background-color: #13639e;
    clip-path: polygon(93% 0, 110% 0, 110% 102%, 0% 102%);
    content: "";
  }
  .quick-links__title:focus:before, .quick-links__title:hover:before {
    background-color: #ffbf00;
  }
  .quick-links__title:after {
    width: 0.5rem;
    color: #ffbf00;
    content: '\\f053';
    font-size: 0.75em;
  }
  .quick-links__title .submenu-toggle {
    display: none;
  }
}
.quick-links__title:hover, .quick-links__title:focus {
  background-color: #ffbf00;
  color: #022851;
  text-decoration: none;
}
@media (min-width: 992px) {
  .quick-links__title:hover, .quick-links__title:focus {
    outline: none;
  }
  .quick-links__title:hover:before, .quick-links__title:focus:before {
    background-color: #ffbf00;
  }
  .quick-links__title:hover:after, .quick-links__title:focus:after {
    color: #022851;
  }
}

`;